import * as React from 'react';
import cn from 'clsx';

import * as styles from './styles.css';

interface ILabelProps {
  label: React.ReactNode;
  children?: React.ReactNode;
  isValuationView?: boolean;
}

export const Label: React.FC<ILabelProps> = ({ label, isValuationView, children }) => {
  return (
    <label>
      <span className={cn(styles['label'], isValuationView && styles['valuation-label'])}>{label}</span>
      {children}
    </label>
  );
};

Label.displayName = 'Label';
